/* eslint-disable no-underscore-dangle */
import { isProduction } from 'utils';

const identity = f => f;

export const addReduxDevtoolsMiddleware = () => {
  if (isProduction()) return identity;

  const isReduxDevToolsNotDefined =
    typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'function';
  if (isReduxDevToolsNotDefined) return identity;

  return window.__REDUX_DEVTOOLS_EXTENSION__();
};
